import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { BaseComponent } from '@app/base.component';
import { Code } from '@app/models/code';
import { HttpService } from '@app/services/http.service';
import { PageTitleService } from '@app/services/page-title.service';
import { environment } from '@env/environment';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-code-detail',
  templateUrl: './code-detail.component.html',
  styleUrls: ['./code-detail.component.css']
})
export class CodeDetailComponent extends BaseComponent implements OnInit {
  
  urlBack: string = null;
  subTitle: string = "Code Details";
  code: Code = new Code();
  isLoaded: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpService: HttpService,
    private appComponent: AppComponent,
    private pageTitleService: PageTitleService) { 
      super();
    }

  ngOnInit(): void {
    this.urlBack = this.router.createUrlTree([ '/administration/codes' ]).toString();
    this.appComponent.appendSiteTitle('Code', 'Detail');
    this.pageTitleService.setPageTitle('Code Administration');

    this.activatedRoute.params
    .pipe( takeUntil( this.appUnsubscribe ) )
    .subscribe(params => {
      if (params.code_id) {
        this.fetchCode(params.code_id);
      }
    });
  }

  fetchCode(code_id: number) {
    let urlApi: string = this.httpService.createUrl([
      'api',
      'codes',
      code_id
    ], {}, { host: environment.host_api_default});

    this.httpService.get<Code>(urlApi).pipe(
      tap( _ => null )
    ).subscribe(data => {
      this.code = data;
    }, () => {
      // do nothing
    }, () => {
      this.isLoaded = true;
    });
  }

  handleEdit(): void {
    this.router.navigate(['administration', 'codes', this.code.code_id, 'edit']);
  }
  
  handleBack(): void {
    this.router.navigateByUrl( this.urlBack );
  }
}
